export enum EPasswordType {
  PASS_MAIN,
  PASS_INVESTOR,
  PASS_API
}

// Account Link APIs params
export interface IAccountLinkParams {
  metatraderId: string;
  password: string;
}

export interface IAccountLinkRemoveParams {
  metatraderId: string;
  passwordType: EPasswordType;
  serverId?: number; // only required if OMS
}
